import {
  getCodeList,
  saveCode,
  editCode,
  deleteCode
} from '@/axios/api/qrCode'
import { Message } from 'element-ui'
import moment from 'moment'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_SEARCH = 'UPDATE_SEARCH'

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    id: '',
    channelName: '',
    creator: '',
    date: []
  }
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      createTime: v.createTime ? moment(v.createTime * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }),
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params,
  detailLoading: state => state.detailLoading
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [UPDATE_DET_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getCodeList(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置筛选条件
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  // 保存二维码
  async saveCodeApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await saveCode(params)
      commit(UPDATE_DET_LOADING, false)
      Message.success('success')
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新角色
  async editCodeApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await editCode(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {}
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 删除二维码
  async deleteCodeApi ({commit}, params) {
    try {
      const res = await deleteCode(params)
      return res
    } catch (e) {
      return false
    }
  },
  
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/qrCode.js